var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRsmLogo = function SvgRsmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 52,
    viewBox: "0 0 122 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4215_3710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.387 0.508362H44.916V13.252H121.387V0.508362Z",
    fill: "#009CDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71191 0.508362H0V13.252H9.71191V0.508362Z",
    fill: "#888B8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4513 0.508362H15.1758V13.252H39.4513V0.508362Z",
    fill: "#3F9C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9417 32.3161C65.9417 29.3143 64.9226 26.8992 62.9956 25.3534C61.013 23.7775 58.7092 23.4007 55.2963 23.4007H44.9121V51.0805H50.5431V28.3851H55.5019C56.9021 28.3851 57.9213 28.5607 58.5936 28.9675C59.5827 29.5499 60.1694 30.629 60.1694 32.3161C60.1694 35.2023 58.3923 36.2214 56.0585 36.2214H52.3074V41.2316H54.5427L60.4006 51.0805H66.9052L60.4006 40.3023C64.1903 39.1933 65.9417 36.0459 65.9417 32.3161Z",
    fill: "#63666A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0058 35.4079C79.0106 34.0376 74.5186 33.862 74.5186 30.8345C74.5186 28.8861 76.3 27.9826 78.835 27.9826C81.3144 27.9826 83.5325 28.2138 87.2623 29.2073V24.1886C84.0549 23.2851 81.7212 22.9639 78.6894 22.9639C73.204 22.9639 68.5664 25.1478 68.5664 30.7146C68.5664 35.1124 70.7503 37.3263 75.071 38.8122C78.9206 40.1268 83.267 40.388 83.267 43.3598C83.267 45.578 81.1088 46.5072 77.9914 46.5072C74.9554 46.5072 73.0627 46.2717 69.183 45.2225V50.2626C72.4203 51.2261 75.1309 51.4916 78.2826 51.4916C85.164 51.4916 89.1935 48.4898 89.1935 42.9273C89.1892 38.521 86.3031 36.5426 83.0058 35.4079Z",
    fill: "#63666A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.034 23.4007L104.15 51.0805H109.516L115.785 33.4809H115.875V51.0805H121.386V23.4007H114.034Z",
    fill: "#63666A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.064 40.6278L99.6282 23.4007H92.1602V51.0805H97.6156V33.4809H97.7055L103.285 48.417L106.064 40.6278Z",
    fill: "#63666A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4215_3710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.588,
    height: 52,
    fill: "white"
  })))));
};
export default SvgRsmLogo;